import { VStack } from '@chakra-ui/react';
import React from 'react';

import { ReceivableReconciliationAlert } from './ReceivableReconciliation/ReceivableReconciliationAlert';
import { ReceivableReconciliationAlertProvider } from './ReceivableReconciliation/ReceivableReconciliationAlertContext';
import { UploadDrawerAlert } from './UploadDrawerAlert';
import { UploadSingleInput } from './UploadSingleInput';
import { useUploadContextMeshInputs } from 'packages/dataPipeline/hooks/UploadContext';
import { SectionHeader } from 'packages/dataPipeline/ui/components/SectionHeader';

export const UploadContainer = ({
  organizationId,
  closeDrawer,
}: {
  organizationId: string;
  closeDrawer: () => void;
}) => {
  const meshInputs = useUploadContextMeshInputs();

  // sort on meshInput.friendlyName alphabetically
  const sortedMeshInputs = [...meshInputs].sort((a, b) => {
    return a.friendlyName.localeCompare(b.friendlyName);
  });
  return (
    <ReceivableReconciliationAlertProvider>
      <UploadDrawerAlert />
      <ReceivableReconciliationAlert />
      <SectionHeader title="Upload Files" />
      <VStack spacing="8px" alignItems="flex-start" width="100%">
        {sortedMeshInputs.map((meshInput) => {
          return (
            <UploadSingleInput
              organizationId={organizationId}
              key={meshInput.artifactId}
              meshInput={meshInput}
              closeDrawer={closeDrawer}
            />
          );
        })}
      </VStack>
    </ReceivableReconciliationAlertProvider>
  );
};
